import React from 'react'

import { nutrimaticLabels } from '@/nutrimatic'
import type { LiquidityPositionsControllerResult } from '@/features/liquidity/useLiquidityPositionsController'
import type { Pair } from '@/sdk'

import {
  LiquidityNutrimaticPlaceholderScene,
  type LiquidityNutrimaticPlaceholderId,
} from './LiquidityNutrimaticPlaceholderScene'
import { LiquidityNutrimaticPositionReadoutDetail } from './LiquidityNutrimaticPositionReadoutDetail'

function resolveReadoutPlaceholder({
  account,
  hasPositions,
  selectedPair,
  loading,
}: {
  account: string | undefined
  hasPositions: boolean
  selectedPair: Pair | null
  loading: boolean
}): LiquidityNutrimaticPlaceholderId | 'detail' {
  if (loading) return 'loading'
  if (!account) return 'connect-wallet'
  if (!hasPositions) return 'no-positions'
  if (!selectedPair) return 'select-position'
  return 'detail'
}

/** Panel izquierdo del hub: detalle LP o escena placeholder ilustrada. */
export function LiquidityNutrimaticReadoutPane({
  controller,
  selectedPair,
}: {
  controller: LiquidityPositionsControllerResult
  selectedPair: Pair | null
}) {
  const { account, allV2PairsWithLiquidity, v2IsLoading } = controller
  const mode = resolveReadoutPlaceholder({
    account,
    hasPositions: allV2PairsWithLiquidity.length > 0,
    selectedPair,
    loading: v2IsLoading,
  })

  return (
    <div className="nm-tablet-readout-pane">
      <header className="nm-tablet-readout-pane__header">
        <p className="nm-tablet-readout-pane__kicker">{nutrimaticLabels.liquidityHub.readoutKicker}</p>
      </header>

      <div className="nm-tablet-readout-pane__body">
        {mode === 'detail' && selectedPair ? (
          <LiquidityNutrimaticPositionReadoutDetail pair={selectedPair} />
        ) : (
          <LiquidityNutrimaticPlaceholderScene
            id={mode as Exclude<typeof mode, 'detail'>}
          />
        )}
      </div>

      {mode === 'detail' ? (
        <footer className="nm-tablet-readout-pane__footer">
          <p className="nm-tablet-readout-pane__footnote">{nutrimaticLabels.liquidityHub.onchainFootnote}</p>
        </footer>
      ) : null}
    </div>
  )
}
